import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";

const pilihanCetak = [
  { value: "halaman_depan", label: "Halaman Depan", bg: "#DBEAFE", text: "#1D4ED8", border: "#93C5FD" },
  { value: "tengah_semester", label: "Tengah Semester", bg: "#EDE9FE", text: "#6D28D9", border: "#C4B5FD" },
  { value: "akhir_semester", label: "Semester Akhir", bg: "#DCFCE7", text: "#166534", border: "#86EFAC" },
];

// props: show, onHide, onSelect (opsional), selectedStudents (opsional).
// onSelect menerima value: "halaman_depan" | "tengah_semester" | "akhir_semester".
// Pemanggilan endpoint cetak massal belum diterapkan.
export default function ModalCetak(props) {
  const [pilihan, setPilihan] = useState("");

  useEffect(() => {
    if (props.show) setPilihan("");
  }, [props.show]);

  const handleConfirm = () => {
    if (!pilihan) return;
    if (typeof props.onSelect === "function") {
      props.onSelect(pilihan);
    }
    props.onHide?.();
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-cetak-rapor"
    >
      <div className="sims-modal-header">
        <h5 id="modal-cetak-rapor" className="sims-modal-title">
          Cetak Seluruh Rapor
        </h5>
        <button type="button" className="sims-modal-close" onClick={props.onHide} aria-label="Tutup modal">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <div className="sims-modal-body">
        <p style={{ marginBottom: 14, fontSize: 14, fontWeight: 600 }}>
          Pilih jenis rapor yang ingin dicetak
        </p>
        <div style={{ display: "flex", flexWrap: "nowrap", gap: 8, width: "100%" }} role="group" aria-label="Jenis rapor">
          {pilihanCetak.map((item) => {
            const isSelected = pilihan === item.value;
            return (
              <button
                key={item.value}
                type="button"
                aria-pressed={isSelected}
                onClick={() => setPilihan(item.value)}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 5,
                  flex: "1 1 0",
                  minWidth: 0,
                  alignItems: "center",
                  padding: "11px 5px",
                  borderRadius: 9,
                  border: `2px solid ${isSelected ? item.text : item.border}`,
                  background: item.bg,
                  color: item.text,
                  fontSize: 12,
                  whiteSpace: "nowrap",
                  fontWeight: 600,
                  cursor: "pointer",
                  boxShadow: isSelected ? `0 0 0 2px ${item.border}` : "none",
                  transition: "border-color .15s, box-shadow .15s",
                }}
              >
                <span>{item.label}</span>
                {isSelected && <FontAwesomeIcon icon={faCheck} aria-hidden="true" />}
              </button>
            );
          })}
        </div>
      </div>

      <div className="sims-modal-footer">
        <button type="button" className="sims-modal-cancel" onClick={props.onHide}>
          Batal
        </button>
        <button
          type="button"
          className="sims-modal-submit"
          disabled={!pilihan}
          onClick={handleConfirm}
        >
          Konfirmasi Pilihan
        </button>
      </div>
    </Modal>
  );
}
